import service from '@/api/request';
import { defineExportApi, definePostApi } from '../utils/define';

export interface EditAdminStuInfoRequest {
  department: string;
  name: string;
  orgId: number;
  rid: string;
  stuNum: string;
}
/** 管理员编辑学生信息 */
export const editAdminStuInfo = definePostApi<EditAdminStuInfoRequest, string>('/api/fkc/editAdminStuInfo');
/** 领队编辑学生信息 */
export const editTeamStuInfo = definePostApi<EditAdminStuInfoRequest, string>('/api/fkc/editTeamStuInfo');

interface QueryAdminPreResultsRequest extends Global.PaginationRequest {
  department: string;
  name: string;
  orgId: number;
  phone: string;
  pictureCheckCode: string;
  pictureCheckKey: string;
}
/** 初赛记录 */
export interface PreResultRecord {
  department: string;
  /** 姓名 */
  name: string;
  orgName: string;
  orgId: number;
  /** 初赛积分 */
  points: string;
  /** 排名 */
  rank: string;
  rid: string;
  /** 带*手机号 */
  starPhone: string;
  /** 学号 */
  stuNum: string;
  /** 通行证uid */
  uid: string;
}
/** 管理员初赛成绩分页查询 */
export const queryAdminPreResults = (params: QueryAdminPreResultsRequest) =>
  service.post<QueryAdminPreResultsRequest, Global.PaginationResponse<PreResultRecord>>(
    '/api/fkc/queryAdminPreResults',
    params
  );
/** 领队初赛成绩分页查询 */
export const queryTeamPreResults = (params: QueryAdminPreResultsRequest) =>
  service.post<QueryAdminPreResultsRequest, Global.PaginationResponse<PreResultRecord>>(
    '/api/fkc/queryTeamPreResults',
    params
  );
/** 上传图片 */
export const uploadImg = params => service.post('/api/fkc/uploadImg', params);

/** 管理员导出 */
export const downloadAdminPreResults = defineExportApi<QueryAdminPreResultsRequest>(
  '/api/fkc/downloadAdminPreResults',
  'excel'
);
/** 领队导出 */
export const downloadTeamPreResults = defineExportApi<QueryAdminPreResultsRequest>(
  '/api/fkc/downloadTeamPreResults',
  'excel'
);

/** 查询初赛是否结束 */
export const queryPreStatus = () => service.post<null, boolean>('/api/fkc/queryPreStatus');

export interface StuDetailInfo {
  department: string;
  name: string;
  orgId: string;
  orgName: string;
  phone: string;
  rid: string;
  stuNum?: string;
}
/** 领队查询学生详情 */
export const queryStuDetailInfo = definePostApi<string, StuDetailInfo>('/api/fkc/queryStuDetailInfo');

// ----- 全国赛接口
export interface FkcFinalResultRecord {
  /** 院系 */
  department?: string;
  /** 答题耗时 */
  second?: string;
  /** 学生姓名 */
  name?: string;
  /** 组织id */
  orgId?: string;
  /** 学校 */
  orgName?: string;
  /** 积分 */
  points?: string;
  /** 全国排名 */
  rank?: number;
  /** 主键id */
  rid?: string;
  /** 学生手机 */
  starPhone?: string;
  /** 学号 */
  stuNum?: string;
}

export type FkcQueryFinalResultsRequest = Global.PaginationRequest &
  Global.PictureCheckRequest &
  Partial<FkcFinalResultRecord>;

/** 管理员决赛成绩分页查询 */
export const queryAdminFinalResults = definePostApi<
  FkcQueryFinalResultsRequest,
  Global.PaginationResponse<FkcFinalResultRecord>
>('/api/fkc/queryAdminFinalResults');
/** 管理员决赛成绩导出 */
export const downloadAdminFinalResults = defineExportApi<FkcQueryFinalResultsRequest>(
  '/api/fkc/downloadAdminFinalResults',
  'excel'
);

/** 领队决赛成绩分页查询 */
export const queryTeamFinalResults = definePostApi<
  FkcQueryFinalResultsRequest,
  Global.PaginationResponse<FkcFinalResultRecord>
>('/api/fkc/queryTeamFinalResults');
/** 领队决赛成绩导出 */
export const downloadTeamFinalResults = defineExportApi<FkcQueryFinalResultsRequest>(
  '/api/fkc/downloadTeamFinalResults',
  'excel'
);

export interface FkcFinalRewardResultRecord {
  /** 院系 */
  department?: string;
  /** 学生姓名 */
  name?: string;
  /** 组织id */
  orgId?: string;
  /** 学校 */
  orgName?: string;
  /** 全国排名 */
  rank?: number;
  /** 奖项 */
  rewardType?: string;
  /** 奖项 */
  rewardTypeStr?: string;
  /** 主键id */
  rid?: string;
  /** 学生手机 */
  starPhone?: string;
  /** 学号 */
  stuNum?: string;
}

/** 管理员查看 决赛获奖名单 */
export const queryAdminFinalRewardResults = definePostApi<
  FkcQueryFinalResultsRequest,
  Global.PaginationResponse<FkcFinalRewardResultRecord>
>('/api/fkc/queryAdminFinalRewardResults');
/** 管理员导出 决赛获奖名单 */
export const downloadAdminFinalRewardResults = defineExportApi<FkcQueryFinalResultsRequest>(
  '/api/fkc/downloadAdminFinalRewardResults',
  'excel'
);

/** 领队查看 决赛获奖名单 */
export const queryTeamFinalRewardResults = definePostApi<
  FkcQueryFinalResultsRequest,
  Global.PaginationResponse<FkcFinalRewardResultRecord>
>('/api/fkc/queryTeamFinalRewardResults');
/** 领队导出 决赛获奖名单 */
export const downloadTeamFinalRewardResults = defineExportApi<FkcQueryFinalResultsRequest>(
  '/api/fkc/downloadTeamFinalRewardResults',
  'excel'
);
